export type AccountRole = 'admin' | 'teacher' | 'student';

export interface AuthUser {
  readonly id: string;
  readonly email: string;
  readonly displayName: string;
  readonly role: AccountRole;
  readonly schoolId: string;
}

export interface AuthSession {
  readonly user: AuthUser;
  readonly expiresAt: string;
}

export type AuthErrorCode =
  | 'account_inactive'
  | 'account_not_provisioned'
  | 'invalid_credentials'
  | 'invalid_request'
  | 'too_many_attempts'
  | 'service_unavailable';

export class AuthError extends Error {
  constructor(
    readonly code: AuthErrorCode,
    message: string
  ) {
    super(message);
    this.name = 'AuthError';
  }
}
